import { getDefaultExportFromCjs } from '../../_virtual/_commonjsHelpers.js';

var isBuffer_1=function(obj){return obj!=null&&(isBuffer(obj)||isSlowBuffer(obj)||!!obj._isBuffer)};function isBuffer(obj){return !!obj.constructor&&typeof obj.constructor.isBuffer==="function"&&obj.constructor.isBuffer(obj)}function isSlowBuffer(obj){return typeof obj.readFloatLE==="function"&&typeof obj.slice==="function"&&isBuffer(obj.slice(0,0))}getDefaultExportFromCjs(isBuffer_1);

export { isBuffer_1 as i };
//# sourceMappingURL=index.js.map
